import { Stepper } from './Stepper'

export interface DishGoals {
  mainGoal: number
  saladGoal: number
  sideGoal: number
  dessertGoal: number
  drinkGoal: number
}

interface Props extends DishGoals {
  setMainGoal: (v: number) => void
  setSaladGoal: (v: number) => void
  setSideGoal: (v: number) => void
  setDessertGoal: (v: number) => void
  setDrinkGoal: (v: number) => void
}

const CATEGORIES = [
  { key: 'mainGoal'    as const, name: 'Mains'    },
  { key: 'saladGoal'  as const, name: 'Salads'   },
  { key: 'sideGoal'   as const, name: 'Sides'    },
  { key: 'dessertGoal'as const, name: 'Desserts' },
  { key: 'drinkGoal'  as const, name: 'Drinks'   },
]

const SETTER_KEYS = {
  mainGoal:    'setMainGoal',
  saladGoal:   'setSaladGoal',
  sideGoal:    'setSideGoal',
  dessertGoal: 'setDessertGoal',
  drinkGoal:   'setDrinkGoal',
} as const

export function DishGoalsFields(props: Props) {
  const total = props.mainGoal + props.saladGoal + props.sideGoal + props.dessertGoal + props.drinkGoal

  return (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-2.5">
        {CATEGORIES.map(({ key, name }) => (
          <div key={key} className="p-3 rounded-xl bg-s2 border border-line-soft">
            <div className="flex justify-center mb-2">
              <span className="text-[12px] font-semibold">{name}</span>
            </div>
            <Stepper value={props[key]} onChange={props[SETTER_KEYS[key]]} />
          </div>
        ))}
      </div>
      <div className="mt-3 text-[11.5px] text-muted">
        Goal: <strong className="text-ink-2">{total} dish{total !== 1 ? 'es' : ''}</strong> across categories.
      </div>
    </div>
  )
}
